import React from 'react';

export const SectionTitle = ({ title }: { title: string }) => {
  return (
    <h1 className="border-b-4 border-black text-2xl font-bold pb-2">{title}</h1>
  );
};
